<template>
  <div>
    <el-dialog
      :title="$t('arealimitset.editpartline')"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="400px"
    >
      <div style="padding: 0 20px">
        <div style="text-align: left">
          <el-form :size="size" label-width="90px">
            <el-form-item :label="$t('arealimitset.partlinename')">
              <el-input v-model="RoutePartName"></el-input>
            </el-form-item>
            <limitvalueset
              v-model="MaxSpeed"
           :label="$t('arealimitset.hightspeed')"
              unit="0～100km/h"
              :min="0"
              :max="100"
            />
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" :size="size">{{$t('public.cancel')}}</el-button>
        <el-button type="primary" @click="saveConfig" :size="size"
          >{{$t('public.confirm')}}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import limitvalueset from "./limitvalueset";
export default {
  computed: {
    size() {
      return this.$store.getters.size;
    },
    operator() {
      return this.$store.getters.operator;
    },
  },
  components: { limitvalueset },
  data() {
    return {
      dialogVisible: false,
      RoutePartID: 0,
      RoutePartName: "",
      MaxSpeed: 60,
      RouteId: 0,
      RPartWidth: 0,
      LeftLon: 0,
      LeftLat: 0,
      RightLon: 0,
      RightLat: 0,
    };
  },
  methods: {
    show(row) {
      this.RouteId = row.RouteID;
      this.RoutePartID = row.RoutePartID;
      this.RoutePartName = row.RoutePartName;
      this.MaxSpeed = row.MaxSpeed;
      this.RPartWidth = row.RPartWidth;
      this.LeftLon = row.LeftLon;
      this.LeftLat = row.LeftLat;
      this.RightLon = row.RightLon;
      this.RightLat = row.RightLat;

      this.dialogVisible = true;
    },
    saveConfig() {
      if (!this.RoutePartName) {
        //提示，请保存路段名称
        this.$message({
          message:this.$t('arealimitset.plsinputpartlinename'),
          type: "warning",
        });
        return;
      }
      if (!this.MaxSpeed) {
        //提示，请保存路段名称
        this.$message({
          message: this.$t('arealimitset.plsinputpartlinespeed'),
          type: "warning",
        });
        return;
      }
      // 提交接口保存
      this.$api.saveRouteLimitInfo({
        routeId: this.RouteId,
        routePartId: this.RoutePartID,
        routePartName: this.RoutePartName,
        partWidth: this.RPartWidth,
        maxSpeed: this.MaxSpeed,
        leftLon: this.LeftLon,
        leftLat: this.LeftLat,
        rightLon: this.RightLon,
        rightLat: this.RightLat,
        CompanyID: this.operator.CompanyId,
        OperatorID: this.operator.OperatorId,
      }).then(res=>{
        //操作成功
        if(res.code==200){
          this.$message({
            message: this.$t('public.hasSaved'),
            type: "success",
          });
          this.$emit("ok");
          this.dialogVisible = false;
        
        }else{
          this.$message({
            message: res.message,
            type: "error",
          });
        }
      });
    },
  },
  mounted() {},
  destroyed() {},
};
</script>
